export default __webpack_public_path__ + "static/media/benefit6.5508b069.svg";